import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ClientService {
    constructor(private http: HttpClient) { }

    getById(_id: string): Observable<object> {
        return this.http.get(`${environment.apiUrl}client/view/${_id}`, {});
    }

    /** Ownership tree of a company, in the same shape as a dossier client row */
    getShareholders(_id: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}client/${_id}/shareholders`);
    }

    updateShareholders(_id: string, shareholders: any[]): Observable<any> {
        return this.http.put(`${environment.apiUrl}client/${_id}/shareholders`, { shareholders });
    }

    getAll(filter?: any): Observable<any[]> {
        return this.http.post<any[]>(
            `${environment.apiUrl}client/list`,
            filter
        );
    }

    createClient(data: any): Observable<object> {
        return this.http.post(`${environment.apiUrl}client/create`, data);
    }

    updateClient(data: any): Observable<object> {
        return this.http.put(
            `${environment.apiUrl}client/update/${data._id}`,
            data
        );
    }
    archiveClient(data: any): Observable<any> {
        return this.http.get(
            `${environment.apiUrl}client/archive/${data._id}`
        );
    }
    deleteClient(data: any): Observable<any> {
        return this.http.delete(
            `${environment.apiUrl}client/delete/${data._id}`
        );
    }
    updateClientsStatus(selectedClients: any): Observable<any> {
        return this.http.post<any[]>(`${environment.apiUrl}client/update-all-clients-status`, selectedClients);
    }

    sendClientVerification(clientId: string, verificationType: 'sms' | 'email'): Observable<any> {
        return this.http.post(`${environment.apiUrl}idverse/client-verification`, {
            clientId,
            type: verificationType
        });
    }

    getKycVerificationLogs(clientId: string, logType: string, portal: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}client/kyc-verification-logs`, {
            client_id: clientId,
            log_type: logType,
            portal: portal
        });
    }

    getKycWebhooks(clientId: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}client/kyc-webhooks`, {
            client_id: clientId
        });
    }

    updateKycStatus(id: string, updatedKyc: any): Observable<any> {
        return this.http.put(`${environment.apiUrl}client/${id}/kyc`, updatedKyc);
    }

    initiateClientKyc(clientId: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}lexis-nexis/initate-list-screening`, {
            client_id: clientId
        });
    }

    getSearchMatches(logId: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}lexis-nexis/search-matches/${logId}`);
    }

    updateRecordState(data: any): Observable<any> {
        return this.http.post(`${environment.apiUrl}lexis-nexis/update-record-state`, data);
    }

    getClientRiskAssessment(clientId: string): Observable<any> {
        return this.http.get(`${environment.apiUrl}client/risk-assessment/${clientId}`);
    }

    saveSelfAssessedRisk(clientId: string, riskType: string, riskLevel: string): Observable<any> {
        return this.http.post(`${environment.apiUrl}client/self-assessed-risk/${clientId}`, {
            riskType,
            riskLevel
        });
    }

    generateClientReport(clientId: string): Observable<{ url: string }> {
        return this.http.get<{ url: string }>(`${environment.apiUrl}client/${clientId}/generate-report`);
    }

    getClientReportHistory(clientId: string): Observable<{ reports: any[] }> {
        return this.http.get<{ reports: any[] }>(`${environment.apiUrl}client/${clientId}/report-history`);
    }

    isClientFromSubmission(clientId: string): Observable<{ is_from_submission: boolean }> {
        return this.http.get<{ is_from_submission: boolean }>(`${environment.apiUrl}client/${clientId}/from-submission`);
    }
}
